import { fetchNotificationStatus } from '~/services/notifications';
import { JobInfo } from './_types';

export enum JobKey {
    NotificationStatus = 'NotificationStatus',
}

export const getJobs = (): JobInfo[] => {
    return [
        {
            key: JobKey.NotificationStatus,
            // 5min
            interval: 5000 * 60,
            jobFn: () => {
                fetchNotificationStatus();
            },
        },
    ];
};
